module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "FM-Head-fmh"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-No-Indent-fmtx1-2"
  }, [_vm._v("Writing is not a solitary endeavor. Thanks as always to my agent, Al Zuckerman, whose wisdom and mentorship continue to raise my game every day; and to my editor, Jen Enderlin, for her astute critiques and sharp eye for clean prose.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d01ac2ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknowledgments.vue
// module id = 69
// module chunks = 0